import { initialCustomerSummary } from './customer-summary/customer-summary.model';
import { ContractDetails } from './contract-details.interface';

export const initialState: ContractDetails = {
  authorization: {
    ACCESS: {
      ORDERS: false,
      FLOWS: false,
      CALENDAR: false,
      INVOICES: false,
      STOCK: false,
      BLANK_RECEIPT: false,
      EMAIL_ACTORS: false,
      REPORTS: false,
    },
    FLOW: {
      QUERY: false,
      GET: false,
      CREATE: false,
      UPDATE: false,
      CANCEL: false,
      ACCEPT: false,
      OVERRULE_MAX: false,
      MULTI_ACCEPT: true,
    },
    INVOICES: {
      ACCESS: false,
      QUERY: false,
      LIST_INVOICES_AS_DOCUMENT: false,
      GET_INVOICE_DOCUMENT: false,
    },
    ORDER: {
      QUERY: false,
      GET: false,
      CREATE: false,
      CREATE_CCR: false,
      UPDATE: false,
      CANCEL: false,
      ACCEPT: false,
      QUERY_TEMPLATE: false,
      GET_TEMPLATE: false,
      CREATE_TEMPLATE: false,
      DELETE_TEMPLATE: false,
      GET_DELIVERY_DATES: false,
      CHECK_PALLET_FLOOR_QUANTITY: false,
      LIST_ORDERS_AS_DOCUMENT: false,
      OVERRULE_MAX: false,
    },
    STOCK: {
      GET_CURRENT_STOCK_LIST: false,
      CREATE: false,
      GET: false,
      QUERY: false,
    },
  },
  loading: false,
  loaded: false,
  selectedCustomerId: null,
  defaults: {
    transport: '',
    localCurrency: 'EUR',
  },
  restrictions: {
    useCcrValidation: false,
    blankReceiptPossible: false,
    deviationManagement: false,
    overruleMaxQty: false,
    GS1LineRef: false,
    palletExchange: false,
    sealNumberRequired: false,
  },
  orderTypes: [],
  orderTypesLoading: false,
  orderTypesLoaded: false,
  allFlowTypes: [],
  flowTypesLoading: false,
  flowTypesLoaded: false,
  flowRegistrationTypes: [],
  flowHandshakeTypes: [],
  places: {},
  customerSummary: initialCustomerSummary,
  handshakes: {},
};
